"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _Text = _interopRequireDefault(require("../../../Text"));

require("./_card-caption.scss");

var CardCaption = function CardCaption(a) {
  var b = a.text,
      c = a.subtitle,
      d = a.fileExtension,
      e = void 0 === d ? "" : d,
      f = a.children;
  return f ? f : _react["default"].createElement("div", {
    className: "card-caption"
  }, _react["default"].createElement("div", {
    className: "card-caption__text"
  }, _react["default"].createElement(_Text["default"], {
    noMargin: !0,
    heading4: !0,
    ellipsisOverflow: !0,
    className: "card-caption__text__title"
  }, b), e && _react["default"].createElement(_Text["default"], {
    noMargin: !0,
    heading4: !0,
    className: "card-caption__text__extension"
  }, ".".concat(e))), c ? _react["default"].createElement(_Text["default"], {
    timestamp: !0
  }, c) : null);
},
    _default = CardCaption;

exports["default"] = _default;